export default __webpack_public_path__ + "static/student_2-center_720-60aaaf602d60507d98f27371d3672164.png";